import { getCountryFromUrl } from '~/core/i18n'

export default defineNuxtRouteMiddleware((to) => {
  if (to.name === 'redirect') {
    return
  }

  const abortWithNotFound = async (reason: string) => abortNavigation({
    message: `abortWithNotFound: ${reason}`,
    statusCode: 404,
  })

  const { hostname } = useRequestURL()
  const country = getCountryFromUrl({ hostname })

  const locale = useAppLocale()

  if (country) {
    locale.currentCountry = country
  }

  if (!country) {
    return abortWithNotFound(`Не получена страна на origin(${useRequestURL().origin})`)
  }
})
